/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    BridgeApiConversationConclusion,
    BridgeApiConversationConclusionFromJSON,
    BridgeApiConversationConclusionToJSON,
    BridgeApiCreateConversationConclusion,
    BridgeApiCreateConversationConclusionFromJSON,
    BridgeApiCreateConversationConclusionToJSON,
    BridgeApiUpdateConversationConclusion,
    BridgeApiUpdateConversationConclusionFromJSON,
    BridgeApiUpdateConversationConclusionToJSON,
} from '../models';

export interface AddConversationConclusionRequest {
    conversationId: string;
    bridgeApiCreateConversationConclusion: BridgeApiCreateConversationConclusion;
}

export interface FindConversationConclusionByConversationIdRequest {
    conversationId: string;
}

export interface UpdateConversationConclusionRequest {
    id: string;
    bridgeApiUpdateConversationConclusion: BridgeApiUpdateConversationConclusion;
}

/**
 * 
 */
export class BridgeConversationConclusionApi extends runtime.BaseAPI {

    /**
     * Creates a new conversation conclusion
     */
    async addConversationConclusionRaw(requestParameters: AddConversationConclusionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BridgeApiConversationConclusion>> {
        if (requestParameters.conversationId === null || requestParameters.conversationId === undefined) {
            throw new runtime.RequiredError('conversationId','Required parameter requestParameters.conversationId was null or undefined when calling addConversationConclusion.');
        }

        if (requestParameters.bridgeApiCreateConversationConclusion === null || requestParameters.bridgeApiCreateConversationConclusion === undefined) {
            throw new runtime.RequiredError('bridgeApiCreateConversationConclusion','Required parameter requestParameters.bridgeApiCreateConversationConclusion was null or undefined when calling addConversationConclusion.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/conversation-conclusion/{conversationId}`.replace(`{${"conversationId"}}`, encodeURIComponent(String(requestParameters.conversationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BridgeApiCreateConversationConclusionToJSON(requestParameters.bridgeApiCreateConversationConclusion),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BridgeApiConversationConclusionFromJSON(jsonValue));
    }

    /**
     * Creates a new conversation conclusion
     */
    async addConversationConclusion(requestParameters: AddConversationConclusionRequest, initOverrides?: RequestInit): Promise<BridgeApiConversationConclusion> {
        const response = await this.addConversationConclusionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches conversation conclusion for conversation
     */
    async findConversationConclusionByConversationIdRaw(requestParameters: FindConversationConclusionByConversationIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BridgeApiConversationConclusion>> {
        if (requestParameters.conversationId === null || requestParameters.conversationId === undefined) {
            throw new runtime.RequiredError('conversationId','Required parameter requestParameters.conversationId was null or undefined when calling findConversationConclusionByConversationId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/conversation-conclusion/{conversationId}`.replace(`{${"conversationId"}}`, encodeURIComponent(String(requestParameters.conversationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BridgeApiConversationConclusionFromJSON(jsonValue));
    }

    /**
     * Fetches conversation conclusion for conversation
     */
    async findConversationConclusionByConversationId(requestParameters: FindConversationConclusionByConversationIdRequest, initOverrides?: RequestInit): Promise<BridgeApiConversationConclusion> {
        const response = await this.findConversationConclusionByConversationIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing conversation conclusion
     */
    async updateConversationConclusionRaw(requestParameters: UpdateConversationConclusionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BridgeApiConversationConclusion>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateConversationConclusion.');
        }

        if (requestParameters.bridgeApiUpdateConversationConclusion === null || requestParameters.bridgeApiUpdateConversationConclusion === undefined) {
            throw new runtime.RequiredError('bridgeApiUpdateConversationConclusion','Required parameter requestParameters.bridgeApiUpdateConversationConclusion was null or undefined when calling updateConversationConclusion.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/conversation-conclusion/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BridgeApiUpdateConversationConclusionToJSON(requestParameters.bridgeApiUpdateConversationConclusion),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BridgeApiConversationConclusionFromJSON(jsonValue));
    }

    /**
     * Update an existing conversation conclusion
     */
    async updateConversationConclusion(requestParameters: UpdateConversationConclusionRequest, initOverrides?: RequestInit): Promise<BridgeApiConversationConclusion> {
        const response = await this.updateConversationConclusionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
